import { Component, OnInit, OnDestroy } from '@angular/core';
import { finalize, Subscription } from 'rxjs';
import { TranslateService } from "@ngx-translate/core";
import { NavigationEnd, Router } from '@angular/router';
import { HomeService } from '../../service/home.service'
import { GraphService } from '../../service/graph.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss']
})
export class HomePage implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = [];
  public totalTransition: number;
  public totalAmount: number;
  public pendingCart: number;
  public expiringCart: number;
  public currentLanguage: string;

  public labelsTransactionAmountDays: any;
  public typeTransactionAmountDays = 'line';
  public legendTransactionAmountDays = false;
  public dataTransactionAmountDays: any;

  public chartTypeTransactionByDays = 'bar';
  public legendTransactionByDays = true;

  public optionTotalDeposit = {
    responsive: true,
    maintainAspectRatio: false,
  }

  public backgroundColor = ["#4473C5", '#009CE6', '#EE8E38', '#BA4E05', '#284576', '#b2e1f7', '#f8d1af', '#7e5f44', '#e3b89b', '#4a1f02', '#a1b9e2', '#005d8a'];

  public optionTransactionByDays = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true
      }
    }
  };

  public chartTypeTransactionByHours = 'bar';
  public legendTransactionByHours = true;
  public optionTransactionByHours = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true
      }
    }
  };

  public chartTypeTransactionByService = "pie";
  public legendTransactionByService = true;
  public optionTransactionByService = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
    }
  }

  public chartAverageAmountTransactionByService = "pie";
  public legendAverageAmountTransactionByService = true;
  public optionAverageAmountTransactionByService = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
    }
  }

  public chartTransactionState = "pie";
  public legendTransactionState = true;
  public optionTransactionState = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
    }
  }

  public chartCartsState = "pie";
  public legendCartsState = true;
  public optionCartsState = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      }
    }
  }

  public chartCartsExpired = "pie";
  public legendCartsExpired = true;
  public optionCartsExpired = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      }
    }
  }

  public chartPosTransaction = "pie";
  public legendPosTransaction = true;
  public optionPosTransaction = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      }
    }
  }

  public columnsToDisplayAmountCustomer = ['customer', 'service', 'transaction', 'amount'];
  public dataAmountCustomer: any;

  public dataDepartment: any;
  public columnsToDisplayDepartment = ['department', 'amount'];

  public dataCity: any;
  public columnsToDisplayCity = ['city', 'amount'];

  public dataPOS: any;
  public columnsToDisplayPOS = ['storename', 'network', 'city', 'amount'];

  public dataTransactionByHours: any;
  public dataTransactionByDays: any;

  public labelsTransactionByService: any;
  public dataTransactionByService: any;

  public labelsPosTransaction: any;
  public dataPosTransaction: any;
  public labelsAverageAmountTransactionByService: any;
  public dataAverageAmountTransactionByService: any;

  public labelsTransactionState: any;
  public dataTransactionState: any;

  public labelsCartsState: any;
  public dataCartsState: any;

  public labelsCartsExpired: any;
  public dataCartsExpired: any;
  constructor(private router: Router, private graphService: GraphService,
    private translateService: TranslateService, private homeService: HomeService) {
  }

  ngOnInit() {
    this.unsubscribe.push(
      this.homeService.getTransactionsToday().pipe(finalize(() => {
      })).subscribe(val => {
        this.totalTransition = (val?.amount__sum || 0).toFixed(2)
      })
    );

    this.unsubscribe.push(
      this.homeService.getTotalAmount().pipe(finalize(() => {
      })).subscribe(val => {
        this.totalAmount = (val["amount__sum"] || 0).toFixed(2)
      })
    );

    this.unsubscribe.push(
      this.homeService.getPendingCart().pipe(finalize(() => {
      })).subscribe(val => {
        this.pendingCart = val["total"] || 0
      })
    );

    this.unsubscribe.push(
      this.homeService.getExpiringCart().pipe(finalize(() => {
      })).subscribe(val => {
        this.expiringCart = val?.amount__sum || 0
      })
    );

    if (this.translateService.currentLang === 'en') {
      this.currentLanguage = 'Français';
    }
    else
      this.currentLanguage = 'English';

    this.unsubscribe.push(this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
      }
    }));

    this.createGraph();
  }

  ngOnDestroy() {
    this.unsubscribe.forEach(s => s.unsubscribe());
  }

  createGraph() {
    this.translateService.stream('a').subscribe(val => {
      this.unsubscribe.push(this.graphService.getTransactionAmountDay().subscribe(val => {
        this.labelsTransactionAmountDays = val["labels"];
        this.dataTransactionAmountDays = [{ data: val["data"], label: ' ', fill: true, backgroundColor: this.backgroundColor }];
      }));



      this.unsubscribe.push(this.graphService.getTransactionByDays().subscribe(val => {
        let labels = val["labels"];
        labels[0] = this.translateService.instant("Sunday");
        labels[1] = this.translateService.instant("Monday");
        labels[2] = this.translateService.instant("Tuesday");
        labels[3] = this.translateService.instant("Wednesday");
        labels[4] = this.translateService.instant("Thursday");
        labels[5] = this.translateService.instant("Friday");
        labels[6] = this.translateService.instant("Saturday");
        val["dataset"] = this.translateLabel(val["dataset"]);
        this.dataTransactionByDays = {
          labels: labels,
          datasets: val['dataset']
        }
      }));

      this.unsubscribe.push(this.graphService.getTransactionByHours().subscribe(val => {
        val["dataset"] = this.translateLabel(val["dataset"]);
        this.dataTransactionByHours = {
          labels: val["hour_of_day"],
          datasets: val['dataset']
        }

      }));

      this.unsubscribe.push(this.graphService.getTransactionByService().subscribe(val => {
        val["labels"] = this.translateLabel(val["labels"]);
        this.labelsTransactionByService = val["labels"];
        this.dataTransactionByService = [{ data: val["data"], label: '', backgroundColor: this.backgroundColor }];
      }));

      this.unsubscribe.push(this.graphService.getTransactionAverageAmountTransactionByService().subscribe(val => {
        val["labels"] = this.translateLabel(val["labels"]);
        this.labelsAverageAmountTransactionByService = val["labels"];
        this.dataAverageAmountTransactionByService = [{ data: val["data"], label: '', backgroundColor: this.backgroundColor }];
      }));

      this.unsubscribe.push(this.graphService.getTransactionState().subscribe(val => {
        val["labels"] = this.translateLabel(val["labels"]);
        this.labelsTransactionState = val["labels"];
        this.dataTransactionState = [{ data: val["data"], label: '', backgroundColor: this.backgroundColor }];
      }));

      this.unsubscribe.push(this.graphService.getCartsState().subscribe(val => {
        val["labels"] = this.translateLabel(val["labels"]);
        this.labelsCartsState = val["labels"];
        this.dataCartsState = [{ data: val["data"], label: '', backgroundColor: this.backgroundColor }];
      }));

      this.unsubscribe.push(this.graphService.getCartsExpired().subscribe(val => {
        val["labels"] = this.translateLabel(val["labels"]);
        this.labelsCartsExpired = val["labels"];
        this.dataCartsExpired = [{ data: val["data"], label: 'Give me a name', backgroundColor: this.backgroundColor }];
      }));

      this.unsubscribe.push(this.graphService.getPosTransaction().subscribe(val => {
        val["labels"] = this.translateLabel(val["labels"]);
        this.labelsPosTransaction = val["labels"];
        this.dataPosTransaction = [{ data: val["data"], label: 'Give me a name', backgroundColor: this.backgroundColor }];
      }));
    })

    this.unsubscribe.push(this.graphService.getAmountCustomer().subscribe(val => {
      this.dataAmountCustomer = val;
    }));

    this.unsubscribe.push(this.graphService.getDataCity().subscribe(val => {
      this.dataCity = val;
    }));

    this.unsubscribe.push(this.graphService.getDataPOS().subscribe(val => {
      this.dataPOS = val;
    }));

    this.unsubscribe.push(this.graphService.getDepartment().subscribe(val => {
      this.dataDepartment = val;
    }))


  }

  private translateLabel(labels) {
    const shopping = this.translateService.instant("Shopping");
    const deposit = this.translateService.instant("Deposit");
    const billing = this.translateService.instant("Billing");
    const total = labels.length

    const identity = this.translateService.instant("IDENTITYCONFIRMED");
    const amount = this.translateService.instant("AMOUNTSET");
    const valide = this.translateService.instant("VALIDATED");
    const cancel = this.translateService.instant("CANCELLED");
    const error = this.translateService.instant("ERROR");
    const transfer = this.translateService.instant("TRANSFERED");
    const pending = this.translateService.instant("PENDING");
    const payed = this.translateService.instant("PAYED");
    const unidentified = this.translateService.instant("UNIDENTIFIED");
    const expired = this.translateService.instant("EXPIRED");
    const noActivity = this.translateService.instant("No activity");
    for (let i = 0; i < total; i++) {
      if (labels[i]["label"] === undefined) {
        if (labels[i].toLowerCase() === "shopping")
          labels[i] = shopping;
        else if (labels[i].toLowerCase() === "deposit")
          labels[i] = deposit;
        else if (labels[i].toLowerCase() === "billing")
          labels[i] = billing;
        else if (labels[i].toLowerCase() === "pending")
          labels[i] = pending;
        else if (labels[i].toLowerCase() === "payed")
          labels[i] = payed;
        else if (labels[i].toLowerCase() === "expired")
          labels[i] = expired;
        else if (labels[i].toLowerCase() === "unidentified")
          labels[i] = unidentified;
        else if (labels[i].toLowerCase() === "identityconfirmed")
          labels[i] = identity;
        else if (labels[i].toLowerCase() === "amountset")
          labels[i] = amount;
        else if (labels[i].toLowerCase() === "validated")
          labels[i] = valide;
        else if (labels[i].toLowerCase() === "cancelled")
          labels[i] = cancel;
        else if (labels[i].toLowerCase() === "error")
          labels[i] = error;
        else if (labels[i].toLowerCase() === "transfered")
          labels[i] = transfer;
        else if (labels[i].toLowerCase() === "no activity")
          labels[i] = noActivity;
      }

      else {
        if (labels[i]["label"].toLowerCase() === "shopping")
          labels[i]["label"] = shopping;
        else if (labels[i]["label"].toLowerCase() === "deposit")
          labels[i]["label"] = deposit;
        else if (labels[i]["label"].toLowerCase() === "billing")
          labels[i]["label"] = billing;
      };
    }
    return labels
  }
}
